import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { REFERRAL_PIPELINE, REFERRAL_STAGE_LABELS } from '../lib/schemas';
import { formatDateTime, toMillis } from '../lib/time';
import { cx } from './ui';
/** Where a lapsed referral had got to: the desk view says so, otherwise the last move to lapsed does. */
function reachedStage(stage, events, lapsedFromStage) {
    if (stage !== 'lapsed')
        return stage;
    if (lapsedFromStage)
        return lapsedFromStage;
    const lapse = [...events].reverse().find((e) => e.to === 'lapsed');
    return lapse?.from ?? null;
}
export const StageTimeline = ({ stage, events, lapsedFromStage }) => {
    const reached = reachedStage(stage, events, lapsedFromStage);
    const reachedIdx = reached ? REFERRAL_PIPELINE.indexOf(reached) : -1;
    const lastAt = (s) => {
        const hits = events.filter((e) => e.to === s).sort((a, b) => (toMillis(a.at) ?? 0) - (toMillis(b.at) ?? 0));
        return hits.length ? hits[hits.length - 1].at : null;
    };
    const rows = REFERRAL_PIPELINE.map((s, i) => ({
        key: s,
        label: REFERRAL_STAGE_LABELS[s],
        state: stage !== 'lapsed' && i === reachedIdx ? 'current' : i <= reachedIdx ? 'done' : 'todo',
        at: i <= reachedIdx ? lastAt(s) : null,
    }));
    if (stage === 'lapsed')
        rows.push({ key: 'lapsed', label: REFERRAL_STAGE_LABELS.lapsed, state: 'lapsed', at: lastAt('lapsed') });
    return (_jsx("ol", { className: "flex flex-col", "aria-label": "Referral progress", children: rows.map((r, i) => (_jsxs("li", { className: "relative flex gap-3 pb-4 last:pb-0", children: [i < rows.length - 1 && _jsx("span", { "aria-hidden": "true", className: "absolute left-[6px] top-4 bottom-0 w-px bg-on-surface/10" }), _jsx("span", { "aria-hidden": "true", className: cx('relative z-10 mt-1 h-3.5 w-3.5 flex-none rounded-full', r.state === 'done' && 'bg-emerald-600', r.state === 'current' && 'bg-[color:var(--pn-brand)] ring-4 ring-on-surface/5', r.state === 'todo' && 'bg-on-surface/15', r.state === 'lapsed' && 'bg-red-600') }), _jsxs("div", { className: "min-w-0", children: [_jsx("div", { className: cx('text-sm font-semibold', r.state === 'todo' && 'text-on-surface-variant/70'), children: r.label }), _jsxs("div", { className: "text-[12.5px] text-on-surface-variant", children: [r.state === 'current' ? 'Current stage' : r.state === 'todo' ? 'Not yet' : r.state === 'lapsed' ? 'Lapsed' : 'Complete', r.at ? ` · ${formatDateTime(r.at)}` : ''] })] })] }, r.key))) }));
};
